(function() {
  'use strict';
  angular
    .module('webAgro1App')
    .directive('blurOnSubmit', BlurOnSubmitDirective);

  function BlurOnSubmitDirective() {
    return {
      restrict: 'A',
      link: {
        // usa pre-link, assim o form salva o valor recalculado vindo dos ng-blur antes do save do form
        pre: function(scope, element) {
          function blurActiveElement() {
            const active = document.activeElement;
            if (active && element[0].contains(active)) {
              active.blur();
            }
          }

          element.on('submit', blurActiveElement);
          scope.$on('$destroy', function() {
            element.off('submit', blurActiveElement);
          });
        }
      }
    };
  }
}());
